<div class="version-information-dialog">
  <div class="version-information-dialog__version">
    {{ 'VersionInformationDialog.AppVersion' | translate }}:
    <span class="version-information-dialog__version--text">{{
      data?.version || ('General.Unknown' | translate)
    }}</span>
  </div>
  <div class="version-information-dialog__version">
    {{ 'VersionInformationDialog.ReleaseDate' | translate }}:
    <span class="version-information-dialog__version--text">{{
      data?.date || ('General.Unknown' | translate)
    }}</span>
  </div>
  <app-release-notes-link></app-release-notes-link>
</div>
